export default (courseId) => {
  console.log('Senting Poll Request');
  return $.ajax({
    url: `/courses/${courseId}/polls`,
    dataType: 'json',
    type: 'POST',
    data: {},
  });
};
